<template>
  <!-- 高级搜索页面 -->
  <div class="seniorSearchComponent">
    <div class="seniorSearch">
      <div class="search_sy_wap">
        <div class="search_sonwap" v-for="(val,ind) in searchList" :key="ind">
          <div class="search_os">
            <el-select v-model="val.type" placeholder="请选择" class="st" v-if="ind != 0">
              <el-option
                v-for="(itemsub,indsub) in type_value"
                :key="indsub"
                :label="itemsub.name"
                :value="itemsub.state"
              ></el-option>
            </el-select>
            
          </div>
          <div class="search_t">
            <el-select v-model="val.state" placeholder="请选择" class="st">
              <el-option
                v-for="(itemsub,indsub) in state_value"
                :key="indsub"
                :label="itemsub.name"
                :value="itemsub.state"
              ></el-option>
            </el-select>
          </div>
          <div class="search_tr">
            <el-input placeholder="请输入内容" v-model="val.content"></el-input>
          </div>
          <div class="search_f">
            <el-select v-model="val.searchType" placeholder="请选择" class="st">
              <el-option
                v-for="(item,ind) in searchType_value"
                :key="ind"
                :label="item.name"
                :value="item.state"
              ></el-option>
            </el-select>
          </div>
          <div
            v-if="ind == 0"
            class="search_but"
            @click="pushsearch(ind)"
            :style="{'color':searchList.length<5?'':'#333','background-color':searchList.length<5?'':'#e6e6e6'}"
          >+</div>
          <div v-else class="search_buts"></div>

          <div
            v-if="ind == 0"
            class="search_but"
            @click="delsearch(ind)"
            :style="{'color':searchList.length>3?'':'#333','background-color':searchList.length>3?'':'#e6e6e6'}"
          >-</div>
          <div v-else class="search_buts"></div>
        </div>

        <div class="btn_wap">
          <div class="btn_o" @click="searchda">
            <img class="btn_o_img" src="../../assets/fdj.png" alt />
            检索
          </div>
          <div class="btn_t" @click="clearval">清空</div>
        </div>
      </div>
    </div>
    <div v-show="sSShow">
      <div class="seniorBotCon" v-if="listShow">
        <leftManin :leftMenuList="leftMenuList" @yearSet="yearSet" />

        <rightManin :parentAddCallBack="parentAddCallBack" :rightMainList="rightMainList" @no-getData="getcontentData" :pages="pageTotal" />

      </div>
      <div class="misswap" v-else>
        <div class="mw_img">
          <img src="../../assets/conmiss.jpg" alt />
        </div>
        <div class="mw_txto">无内容</div>
        <div class="mw_txtt">抱歉，暂无相关结果请更换搜索词再试一下</div>
      </div>
    </div>

    <div style="height:200px;"></div>
  </div>
</template>

<script>
import rightManin from "../searchResult/searchResultComponents/rightMain";
import leftManin from "../searchResult/searchResultComponents/leftMenu";
import { advancedSearchInterface, vintage_interface } from "@/api/lyl";
import { getToken } from "../../../static/js/util.js";


export default {
  name: "seniorSearchComponent",
  data() {
    return {
      sSShow: false,
      content_json: [],
      rjournals_json: [],
      rAuthors_json: [],
      rCates_json: [],
      rTitles_json: [],
      listShow: true,
      listyear: "",
      rightMainList: [],
      rigthList: "",
      leftMenuList: [],
      pageTotal: 0,
      // 搜索下拉
      type_value: [{ name: "与", state: "1" }, { name: "或", state: "2" }],
      state_value: [
        { name: "正文", state: "1" },
        { name: "期刊", state: "2" },
        { name: "栏目", state: "3" },
        { name: "作者", state: "4" },
        { name: "标题", state: "5" }
      ],
      searchType_value: [
        { name: "精确", state: "2" },
        { name: "模糊", state: "1" }
      ],
      searchList: [
        {
          type: "1",
          state: "1",
          content: "",
          searchType: "2"
        },
        {
          type: "1",
          state: "5",
          content: "",
          searchType: "2"
        },
        {
          type: "1",
          state: "2",
          content: "",
          searchType: "2"
        }
      ]
    };
  },
  mounted() {
    // this.yearList();
  },
  watch: {
    pageTotal() {
      // this.$nextTick(() => {
      this.pageTotal = this.rightMainList.total;

      // alert(this.rightMainList.total)
      // });
    }
  },
  methods: {
    parentAddCallBack(){
      this.seniorSearch();
    },
    yearSet(res) {
      this.rigthList.page.page = 1;
      this.listyear = res;
      this.seniorSearch();
    },

    // 高级搜索接口
    async seniorSearch() {
      let content_json = [];
      let rjournals_json = [];
      let rAuthors_json = [];
      let rCates_json = [];
      let rTitles_json = [];
      this.searchList.forEach(function(item, index) {
        // console.log(item);
        if (item.state == 1) {
          item.content ? content_json.push(item) : "";
        } else if (item.state == 2) {
          item.content ? rjournals_json.push(item) : "";
        } else if (item.state == 3) {
          item.content ? rCates_json.push(item) : "";
        } else if (item.state == 4) {
          item.content ? rAuthors_json.push(item) : "";
        } else if (item.state == 5) {
          item.content ? rTitles_json.push(item) : "";
        }
      });
      this.content_json = content_json;
      this.rjournals_json = rjournals_json;
      this.rAuthors_json = rAuthors_json;
      this.rCates_json = rCates_json;
      this.rTitles_json = rTitles_json;
      try {
        // const {content_json} = this
        this.listShow = true;
        const data = await advancedSearchInterface({
          // content_json: JSON.stringify(this.searchList[0]),
          // rjournals_json: JSON.stringify(this.searchList[1]),
          // rAuthors_json: JSON.stringify(this.searchList[2]),
          // rCates_json: JSON.stringify(this.searchList[3]),
          // rTitles_json: JSON.stringify(this.searchList[4]),
          content_json:
            JSON.stringify(this.content_json) === "[]"
              ? ""
              : JSON.stringify(this.content_json),
          rjournals_json:
            JSON.stringify(this.rjournals_json) === "[]"
              ? ""
              : JSON.stringify(this.rjournals_json),
          rAuthors_json:
            JSON.stringify(this.rAuthors_json) === "[]"
              ? ""
              : JSON.stringify(this.rAuthors_json),
          rCates_json:
            JSON.stringify(this.rCates_json) === "[]"
              ? ""
              : JSON.stringify(this.rCates_json),
          rTitles_json:
            JSON.stringify(this.rTitles_json) === "[]"
              ? ""
              : JSON.stringify(this.rTitles_json),
          page: this.rigthList.page.page,
          pageSize: this.rigthList.page.pageSize,
          order_type: this.rigthList.invalidStillRelevant,
          has_img: this.rigthList.layout,
          year: this.listyear,
          search_type: "1",
          AudioRights:this.rigthList.audioRights,
          is_auth:this.rigthList.authorizationnumber,    
          uid: getToken("unique_code"),
          p_uid:this.$store.state.userInfo.admin_code
        });
        (this.rightMainList = data), (this.pageTotal = data.total);
      } catch (err) {
        if (err.code == -1) {
          this.listShow = false;
        }
        // this.$message.error(err.message);
      }
    },


    //年份-文章量接口
    async yearList() {
      let content_json = [];
      let rjournals_json = [];
      let rAuthors_json = [];
      let rCates_json = [];
      let rTitles_json = [];
      this.searchList.forEach(function(item, index) {
        // console.log(item);
        if (item.state == 1) {
          item.content ? content_json.push(item) : "";
        } else if (item.state == 2) {
          item.content ? rjournals_json.push(item) : "";
        } else if (item.state == 3) {
          item.content ? rCates_json.push(item) : "";
        } else if (item.state == 4) {
          item.content ? rAuthors_json.push(item) : "";
        } else if (item.state == 5) {
          item.content ? rTitles_json.push(item) : "";
        }
      });
      this.content_json = content_json;
      this.rjournals_json = rjournals_json;
      this.rAuthors_json = rAuthors_json;
      this.rCates_json = rCates_json;
      this.rTitles_json = rTitles_json;
      try {
        const data = await vintage_interface({
          key: "",
          value: "",
          content_json:
            JSON.stringify(this.content_json) === "[]"
              ? ""
              : JSON.stringify(this.content_json),
          rjournals_json:
            JSON.stringify(this.rjournals_json) === "[]"
              ? ""
              : JSON.stringify(this.rjournals_json),
          rAuthors_json:
            JSON.stringify(this.rAuthors_json) === "[]"
              ? ""
              : JSON.stringify(this.rAuthors_json),
          rCates_json:
            JSON.stringify(this.rCates_json) === "[]"
              ? ""
              : JSON.stringify(this.rCates_json),
          rTitles_json:
            JSON.stringify(this.rTitles_json) === "[]"
              ? ""
              : JSON.stringify(this.rTitles_json),
          page: this.rigthList.page.page,
          pageSize: this.rigthList.page.pageSize,
          order_type: this.rigthList.invalidStillRelevant,
          has_img: this.rigthList.layout,
          year: this.listyear,
          uid: getToken("unique_code"),
          search_type: "1",
          AudioRights:this.rigthList.audioRights,
          is_auth:this.rigthList.authorizationnumber,
          p_uid:this.$store.state.userInfo.admin_code
        });
        // console.log(data)
        this.leftMenuList = data;
      } catch (err) {
        this.$message.error(err.message);
      }
    },

    // 开始搜索框
    searchda() {
      this.leftMenuList = []
      this.rightMainList = []
      this.rigthList.page.page = 1;
      this.sSShow = true;
      this.yearList();
      this.seniorSearch();
    },
    // 清除搜索框
    clearval() {
      this.searchList.forEach(function(item, index) {
        item.content = "";
      });
    },
    // 增加搜索框
    pushsearch(i) {
      this.add_stata = this.add_stata + 1;
      if (this.searchList.length < 5) {
        this.add_stata = "5";
        this.searchList.push({
          type: "1",
          state: String(this.searchList.length),
          content: "",
          searchType: "2"
        });
      } else {
        this.add_stata = "5";
        return;
      }
    },
    // 减少搜索框
    delsearch() {
      if (this.searchList.length > 3) {
        this.searchList.pop();
      } else {
        return;
      }
    },
    getcontentData(res) {
      this.rigthList = res.data;
      this.seniorSearch();
    }
  },
  components: {
    rightManin,
    leftManin
  }
};
</script>

<style scoped lang="less">
.seniorSearchComponent {
  // background:#f9f9f9;
  padding: 40px 0;
  box-sizing: border-box;
  .seniorSearch {
    width: 1200px;
    background: #fff;
    border-radius: 6px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    margin: 0 auto;
    .search_sy_wap {
      width: 780px;
      padding: 40px 0;
      box-sizing: border-box;
      margin: 0 auto;
      .search_sonwap {
        width: 100%;
        height: 40px;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-around;
        margin-top: 20px;
        .search_o {
          width: 80px;
          height: 100%;
        }
        .search_os {
          width: 95px;
          height: 100%;
          border-radius: 4px;
          .st {
            width: 100%;
            height: 100%;
            display: block;
            text-align: center;
            line-height: 40px;
          }
          .stf {
            // width: 70%;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            line-height: 40px;
            text-align: left;
            outline: none;
            display: inline-block;
          }
          .el_icon {
            text-align: right;
          }
          .search_but {
            display: none;
          }
        }
        .search_t {
          width: 124px;
          height: 100%;
          border-radius: 4px;
          .st {
            width: 100%;
            height: 100%;
            display: block;
            text-align: center;
            line-height: 40px;
          }
          .stf {
            width: 70%;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            line-height: 40px;
            text-align: left;
            outline: none;
            display: inline-block;
          }
          .el_icon {
            text-align: right;
          }
        }
        .search_tr {
          width: 300px;
          height: 100%;
        }
        .search_f {
          width: 104px;
          height: 100%;
          border-radius: 4px;
          .st {
            width: 100%;
            height: 100%;
            display: block;
            text-align: center;
            line-height: 40px;
          }
          .stf {
            width: 70%;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
            line-height: 40px;
            text-align: left;
            outline: none;
            display: inline-block;
          }
          .el_icon {
            text-align: right;
          }
        }
        .search_but {
          width: 40px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          background: #0083f1;
          font-size: 16px;
          font-weight: 600;
          border-radius: 4px;
          cursor: pointer;
          color: #fff;
        }
        .search_buts {
          width: 40px;
          height: 40px;
        }
      }
    }
    .btn_wap {
      width: 420px;
      margin: 40px auto;
      display: flex;
      justify-content: space-around;
      cursor: pointer;

      .btn_o {
        width: 200px;
        height: 40px;
        background: rgba(21, 47, 106, 1);
        border-radius: 4px;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        .btn_o_img {
          width: 12px;
          height: 12px;
          display: inline-block;
        }
      }
      .btn_t {
        width: 200px;
        height: 40px;
        background: rgba(21, 47, 106, 1);
        border-radius: 4px;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
  .seniorBotCon {
    width: 1200px;
    display: flex;
    justify-content: space-between;
    margin: 40px auto 0 auto;
  }
  .misswap {
    width: 1200px;
    margin: 40px auto;
    background: #fff;
    padding: 24px 0 40px 0;
    box-sizing: border-box;
    .mw_img {
      width: 702px;
      height: 480px;
      margin: 0 auto;
      img {
        width: 100%;
      }
    }
    .mw_txto {
      font-size: 18px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 25px;
      text-align: center;
    }
    .mw_txtt {
      font-size: 18px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
      text-align: center;
      margin-top: 11px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/seniorSearch/seniorSearch.vue